import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsFilePdf } from "react-icons/bs";
import { AiOutlineFileExcel } from "react-icons/ai";
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import CustomRadioButton from 'components/backoffice/customRadiobutton';
import FooterModal from 'components/backoffice/modals/FooterModal';

const ExportModal = ({ title, show, setShow, handleSave}) => {
  const { t } = useTranslation(['backoffice']);
  const [typeExport, setTypeExport] = useState('');

  const handleSaveCustom = () => {
    handleSave(typeExport);
    setTypeExport('');
  }

  const handleCloseCustom = () => {
    setShow(false);
    setTypeExport('');
  }

  return (
    <ModalCustom
      show={show}
      onHide={handleCloseCustom}
      title={title}
      size='md'
      centered={true}
      footer={<FooterModal onCancel={handleCloseCustom} onSave={handleSaveCustom} disabled={typeExport === ''} saveMsg={t('export')} />}
    >
      <Row className='d-flex flex-row justify-content-start'>
        <Col md={6} className='d-flex justify-content-center'>
          <div className={`d-flex flex-column align-items-center justify-content-center outlined p-3 ${typeExport === 'pdf' && 'selected'}`}>
            <BsFilePdf size={50} />
            <CustomRadioButton
              outlined={true}
              label='PDF'
              name='typeExport'
              onChange={() => setTypeExport('pdf')}
              checked={typeExport === 'pdf'} 
            />
          </div>
        </Col>
        <Col md={6} className='d-flex justify-content-center'>
          <div className={`d-flex flex-column align-items-center justify-content-center outlined p-3 ${typeExport === 'excel' && 'selected'}`}>
            <AiOutlineFileExcel size={50} />
            <CustomRadioButton
              outlined={true}
              label='Excel'
              name='typeExport'
              onChange={() => setTypeExport('excel')}
              checked={typeExport === 'excel'} />
          </div>
        </Col>
      </Row>
    </ModalCustom>
  );
};

ExportModal.prototype = {
  title: PropTypes.string,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired
};

export default ExportModal;
